import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from '../services/authenticate.service';
import { NotificationService } from '../services/notification.service';
import { LoaderService } from '../shared/loader/loader.service';
import * as constants from '../config/app.constants';
@Component({
    selector: 'app-forgot_password',
    templateUrl: 'forgot_password.component.html',
    styleUrls: ['forgot_password.component.css'],
    standalone: false
})
export class Forgot_passwordComponent {
  form: FormGroup = new FormGroup({});
  showForgotPassword: boolean = false;
  requested: Boolean = false;
  constructor(private authService: AuthService,
    private router: Router
    , private toast: NotificationService
    , private loader: LoaderService) {
    this.initiateFormGroup();
  }

  initiateFormGroup() {
    this.form = new FormGroup({
      'email': new FormControl("", [Validators.required, Validators.pattern(constants.VALIDATE_EMAIL_ADDRESS)])
    })
  }

  submitPage() {
    this.requested = false;
    if (this.validatePage()) {
      this.loader.start();
      this.authService.resetPasswordRequest(this.form.get("email")?.value).subscribe(res => {
        this.requested = true;
        this.loader.stop();
      }
        ,
        error => {
          this.loader.stop();
          if (error) {
            if (error.status == 200) {
              this.requested = true;
            } else {
              this.toast.showError(error.error.apierror.message);
            }
          } else {
            this.toast.showError("Error occured while saving");
          }
        }
      )
    }
  }

  reset() {
    this.form.reset();
  }

  validatePage(): boolean {
    Object.keys(this.form.controls).forEach(key => {
      if (key !== null) {
        this.form.get(key)?.markAsDirty();
        this.form.get(key)?.markAsTouched();
      }
    })
    return this.form.valid;
  }
}